import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { getHCCDefinitions } from "apiHandler/actions";
import { useUserData } from "components/customHooks/userDataContext";
import { DataGridCustomPagination } from "components/helpers";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";

const HccCategories = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const userData = useUserData();
  const practiceId = userData?.selected_practice;
  const token = userData?.access_token;

  useEffect(() => {
    fetchHccCategories();
  }, []);

  const fetchHccCategories = async () => {
    setRows([]);
    try {
      const payload = {
        practice_id: practiceId,
      };
      const res = await getHCCDefinitions(payload, token);
      if (res) {
        const formattedRows = res.map((item, index) => ({
          id: index,
          category: item.hcc_category,
          number: item.hcc_details.number,
          type: item.hcc_details.type,
          description: item.hcc_details.descr,
        }));
        setRows(formattedRows);
      }
    } catch (error) {
      console.error("Error fetching HCC Categories:", error);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    { field: "category", headerName: "HCC Category", minWidth: 150 },
    { field: "number", headerName: "Number", width: 100 },
    { field: "type", headerName: "Type", minWidth: 150 },
    {
      field: "description",
      headerName: "Description",
      flex: 2,
      renderCell: (params) => (
        <Box
          sx={{
            whiteSpace: "normal",
            wordBreak: "break-word",
            lineHeight: 1.4,
            py: 1, // vertical padding
          }}
        >
          {params.value}
        </Box>
      ),
    },
  ];

  return (
    <DataGrid
      rows={rows}
      columns={columns}
      loading={loading}
      pagination
      getRowHeight={() => "auto"}
      autoHeight
      slotProps={{
        loadingOverlay: {
          variant: "linear-progress",
          noRowsVariant: "linear-progress",
        },
      }}
      getRowId={(row) => row.id}
      slots={{
        pagination: DataGridCustomPagination,
        toolbar: GridToolbar,
      }}
    />
  );
};

export default HccCategories;
